import { useState, useEffect } from "react";
import {
  Alert,
  Button,
  CircularProgress,
  TextField,
  DialogActions,
  DialogContent,
} from "@mui/material";
import ResponsiveDialog from "../UI/ResponsiveDialog";
import { useMutation } from "@apollo/client";
import {
  UPDATE_PLAYER,
  GET_PLAYERS_BY_TEAM_ID,
  GET_PLAYER,
} from "../../GraphQL/Players";
import useNotification from "../../hooks/useNotification.js";

const EditPlayerDialog = (props) => {
  const [player, setPlayer] = useState(props.player);
  const { notifySuccess } = useNotification();

  useEffect(() => {
    setPlayer(props.player);
  }, [props]);

  const isValid = !!(player?.name?.trim());

  const [updatePlayer, { loading, error }] = useMutation(UPDATE_PLAYER, {
    variables: {
      id: player.id,
      name: player.name,
    },
    refetchQueries: [GET_PLAYERS_BY_TEAM_ID, GET_PLAYER],
    onCompleted: () => { notifySuccess("Player updated."); props.setOpen(false); },
  });

  return (
    <div>
      <ResponsiveDialog
        open={props.open}
        onKeyDown={(e) => {
          if (e.key === "Enter" && isValid) {
            updatePlayer();
          } else if (e.key === "Escape") {
            props.setOpen(false);
          }
        }}
        title="Player"
        onClose={() => props.setOpen(false)}
      >
        <DialogContent>
          <TextField
            data-testid="name"
            autoFocus
            margin="dense"
            id="name"
            label="Name"
            type="text"
            fullWidth
            variant="standard"
            defaultValue={props.player.name}
            onChange={(e) => {
              setPlayer({ ...player, name: e.target.value });
            }}
          />
        </DialogContent>
        {error && (
          <Alert severity="error" sx={{ mx: 2, mb: 1 }}>
            {error.message}
          </Alert>
        )}
        <DialogActions>
          <Button
            data-testid="saveEditPlayerDialogButton"
            variant="contained"
            onClick={() => updatePlayer()}
            disabled={loading || !isValid}
          >
            {loading ? (
              <CircularProgress size={20} sx={{ color: "inherit" }} />
            ) : (
              "Update"
            )}
          </Button>
          <Button
            data-testid="closeEditPlayerDialogButton"
            onClick={() => props.setOpen(false)}
          >
            Cancel
          </Button>
        </DialogActions>
      </ResponsiveDialog>
    </div>
  );
};

export default EditPlayerDialog;
